export var wordCounter = function wordCounter(text) {
  var filteredWords = text.trim().replace(/['";:,.?¿\-!¡]+/g, '');
  return filteredWords ? (filteredWords.match(/\S+/g) || []).length : 0;
};